// extracted by mini-css-extract-plugin
export default {"date":"date-DInt8","icon":"icon-M4tl4"};